import type { ReactNode } from "react";
import { Link } from "react-router";
import { Lock } from "lucide-react";
import { Card, CardTitle, Subtitle, VButton } from "@/components/ui";
import type { V2Role } from "@/v2/shared/model";
import { roleLabels } from "@/v2/shared/statusMeta";
import { useCurrentRole } from "@/v2/auth/useCurrentUser";

type RequireRoleProps = {
  roles: ReadonlyArray<V2Role>;
  children: ReactNode;
};

export function RequireRole({ roles, children }: RequireRoleProps): React.JSX.Element {
  const role = useCurrentRole();
  if (!roles.includes(role)) {
    return (
      <Card padding="lg" className="mx-auto max-w-md space-y-3 text-center">
        <Lock className="mx-auto size-8 text-muted-foreground" aria-hidden />
        <CardTitle>Geen toegang</CardTitle>
        <Subtitle>
          Deze pagina is enkel toegankelijk voor: {roles.map((r) => roleLabels[r]).join(", ")}.
        </Subtitle>
        <VButton asChild variant="outline" size="sm">
          <Link to="/">Terug naar dashboard</Link>
        </VButton>
      </Card>
    );
  }
  return <>{children}</>;
}
